<template>
  <g>
    <g transform="scale(1.5)">
        <text transform="matrix(1 0 0 1 -10 0)" class="name">
            택트 스위치{{ number }}
        </text>
      <defs>
        <clipPath id="clip-path" transform="translate(-247.76 -185.02)">
            <path class="cls-1"
                d="M269.69,213.52l-.77.72a8.52,8.52,0,1,0-11.62-12.45l.77-.72a8.45,8.45,0,0,1,5-2.26,8.52,8.52,0,0,1,6.64,14.71Z" />
        </clipPath>
        <clipPath id="clip-path-2" transform="translate(-247.76 -185.02)">
            <path class="cls-1"
                d="M268.92,214.24a8.5,8.5,0,0,1-5,2.26l.09-.09.1-.09.1-.09.1-.09.1-.1.1-.09.09-.09.09-.08a8.5,8.5,0,0,0,5-2.26Z" />
        </clipPath>
        <clipPath id="clip-path-3" transform="translate(-247.76 -185.02)">
            <path class="cls-1"
                d="M263.93,216.5a8.53,8.53,0,0,1-3.36-.35l.77-.72a8.55,8.55,0,0,0,3.36.35l-.38.36-.05,0-.2.19-.05,0S264,216.48,263.93,216.5Z" />
        </clipPath>
        <clipPath id="clip-path-4" transform="translate(-247.76 -185.02)">
            <path class="cls-1"
                d="M254.62,208.84a8.52,8.52,0,0,1,2.68-7.05l.77-.72a8.51,8.51,0,0,0,3.27,14.36l-.77.72A8.55,8.55,0,0,1,254.62,208.84Z" />
        </clipPath>
        <clipPath id="clip-path-5" transform="translate(-247.76 -185.02)">
            <path class="cls-1" d="M269.86,213.71l-.77.72a8.77,8.77,0,1,1-12-12.83l.77-.72a8.77,8.77,0,1,0,12,12.83Z" />
        </clipPath>
    </defs>
    <title>스위치 버튼</title>
    <g class="pin" style="transform: translate(0px, 2.5px)">
        <rect class="cls-2" x="2.32" width="2.86" height="9.37" rx="1.29" />
        <rect
            :id="`${pincode}BS`"
            @click="onClick(`${pincode}BS`)"
            class="pin-cover terminal snap"
            x="0"
            y="-4"
            width="8"
            height="8"
        />
        <text transform="matrix(1 0 0 1 -10 0)" class="pin-name">B</text>
    </g>
    <g class="pin" style="transform: translate(0px, 2.5px)">
        <rect class="cls-2" x="25.99" width="2.86" height="9.37" rx="1.29" />
        <rect
            :id="`${pincode}DS`"
            @click="onClick(`${pincode}DS`)"
            class="pin-cover terminal snap"
            x="23"
            y="-4"
            width="8"
            height="8"
        />
        <text transform="matrix(1 0 0 1 35 0)" class="pin-name">D</text>
    </g>
    <g class="pin" style="transform: translate(0px, -2.5px)">
        <rect class="cls-2" x="2.62" y="36.12" width="2.86" height="9.37" rx="1.29" />
        <rect
            :id="`${pincode}AS`"
            @click="onClick(`${pincode}AS`)"
            class="pin-cover terminal snap"
            x="0"
            y="42"
            width="8"
            height="8"
        />
        <text transform="matrix(1 0 0 1 -10 60)" class="pin-name">A</text>
    </g>
    <g class="pin" style="transform: translate(0px, -2.5px)">
        <rect class="cls-2" x="25.99" y="36.12" width="2.86" height="9.37" rx="1.29" />
        <rect
            :id="`${pincode}CS`"
            @click="onClick(`${pincode}CS`)"
            class="pin-cover terminal snap"
            x="23"
            y="42"
            width="8"
            height="8"
        />
        <text transform="matrix(1 0 0 1 35 60)" class="pin-name">C</text>
    </g>
    <rect class="cls-3" x="0.13" y="7.03" width="31.21" height="31.21" rx="2.83" />
    <circle class="cls-4" cx="4.51" cy="11.72" r="2.81" />
    <circle class="cls-4" cx="4.51" cy="33.55" r="2.81" />
    <circle class="cls-4" cx="26.95" cy="11.72" r="2.81" />
    <circle class="cls-4" cx="26.84" cy="33.55" r="2.81" />
    <g class="cls-5">
        <g class="cls-5">
            <g class="cls-6">
                <g class="cls-5">
                    <path class="cls-7"
                        d="M269.69,213.52l-.77.72a8.52,8.52,0,1,0-11.62-12.45l.77-.72a8.45,8.45,0,0,1,5-2.26,8.52,8.52,0,0,1,6.64,14.71"
                        transform="translate(-247.76 -185.02)" />
                </g>
            </g>
        </g>
        <g class="cls-5">
            <g class="cls-8">
                <g class="cls-5">
                    <path class="cls-9"
                        d="M269.69,213.52l-.77.72a8.52,8.52,0,1,1-11.62-12.45l.77-.72a8.52,8.52,0,1,0,11.62,12.45"
                        transform="translate(-247.76 -185.02)" />
                </g>
            </g>
        </g>
        <g class="cls-5">
            <g class="cls-10">
                <g class="cls-5">
                    <path class="cls-9"
                        d="M269.69,213.52l-.77.72a8.52,8.52,0,1,1-11.62-12.45l.77-.72a8.52,8.52,0,1,0,11.62,12.45"
                        transform="translate(-247.76 -185.02)" />
                </g>
            </g>
        </g>
        <g class="cls-5">
            <g class="cls-11">
                <g class="cls-5">
                    <path class="cls-9"
                        d="M269.69,213.52l-.77.72a8.52,8.52,0,1,1-11.62-12.45l.77-.72a8.52,8.52,0,1,0,11.62,12.45"
                        transform="translate(-247.76 -185.02)" />
                </g>
            </g>
        </g>
        <g class="cls-5">
            <g class="cls-12">
                <g class="cls-5">
                    <path class="cls-7"
                        d="M269.86,213.71l-.77.72a8.77,8.77,0,1,1-12-12.83l.77-.72a8.77,8.77,0,1,0,12,12.83"
                        transform="translate(-247.76 -185.02)" />
                </g>
            </g>
        </g>
        <path class="cls-13"
            d="M263,198.56a8.78,8.78,0,1,1-7.89,9.58A8.8,8.8,0,0,1,263,198.56Zm1.67,17.22a8.53,8.53,0,1,0-9.31-7.66,8.54,8.54,0,0,0,9.31,7.66"
            transform="translate(-247.76 -185.02)" />
        <g @click="pushButton">
            <circle :class="{'cls-9':!push, 'on': push && on}" cx="263.88" cy="207.3" r="8.52" transform="translate(-318.36 49.31) rotate(-42.77)" />
            <text v-if="on" transform="matrix(1 0 0 1 9 26)" style="stroke:white; font-size: 8px">{{ push? 'ON': 'OFF'}}</text>
        </g>
    </g>
    <circle class="cls-14" cx="3.49" cy="10.41" r="0.55" />
    <circle class="cls-14" cx="3.49" cy="32.5" r="0.55" />
    <circle class="cls-14" cx="25.99" cy="32.5" r="0.55" />
    <circle class="cls-14" cx="25.99" cy="10.48" r="0.55" />
    </g>
 </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'TagSwitch',
  data () {
    return {
      on: false,
      push: false,
      socket: null
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    pushButton (e) {
      if (this.on) {
        window.event.stopPropagation()
        this.push = !this.push
        const value = this.push ? 1 : 0
        store.commit('socket/sendMessage', { socket: this.socket, message: { value } })
      } else {
        this.on = true
      }
    },
    start (socket) {
      this.socket = socket
      this.on = true
      this.push = false
      store.commit('socket/sendMessage', { socket: this.socket, message: { value: 0 } })
    },
    off () {
      this.on = false
    }
  }
}
</script>

<style lang="scss" scoped>
.pin {
    stroke-width: 1px;
    stroke: #514e55;
}
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}
.pin-name {
    display: none;
    font-size: 10px;
    stroke: none;
}
.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
    .pin-name {
        display: block;
    }
}
.selected {
    & rect.cls-3{
        stroke-width: 1.5px;
        stroke: #ff6f61;
    }
}
.name {
    font-size: 10px;
}
.on{
    fill: #ff6f61;
}
.cls-1 {
    fill: none;
}

.cls-2 {
    fill: #898989;
}

.cls-3 {
    fill: #b5b5b5;
    stroke: #595757;
    stroke-miterlimit: 10;
    stroke-width: 0.25px;
}

.cls-4 {
    fill: #1f2020;
}

.cls-5 {
    isolation: isolate;
}

.cls-6 {
    clip-path: url(#clip-path);
}

.cls-7 {
    fill: #515253;
}

.cls-8 {
    clip-path: url(#clip-path-2);
}

.cls-9 {
    fill: #1e1f1f;
}

.cls-10 {
    clip-path: url(#clip-path-3);
}

.cls-11 {
    clip-path: url(#clip-path-4);
}

.cls-12 {
    clip-path: url(#clip-path-5);
}

.cls-13 {
    fill: #777;
}

.cls-14 {
    fill: #fff;
}
</style>
